import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const tipoHitoService = {
  getAll,
  guardarTipoHito,
  deleteTipoGasto,
}

async function getAll() {
  return await ApiBudgety.get('TipoHito/GetAll/')
}

async function guardarTipoHito(tipoHito) {
  return await ApiBudgety.post('TipoHito/InsertOrUpdate/', tipoHito, {
    headers: {
      ACCION: MenusSistema.mantenedor_hito.accesos.crear_editar_hito,
      MENU: MenusSistema.mantenedor_hito.id,
    },
  })
}

async function deleteTipoGasto(id) {
  return await ApiBudgety.post('TipoHito/Delete/' + id, null, {
    headers: {
      ACCION: MenusSistema.mantenedor_hito.accesos.remover_hito,
      MENU: MenusSistema.mantenedor_hito.id,
    },
  })
}
